import toString from 'lodash/toString';
import { AuthTokensResponse } from '@features/auth/types';

const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  ACCESS_TOKEN_EXPIRES_AT: 'access_token_expires_at',
  REFRESH_TOKEN_EXPIRES_AT: 'refresh_token_expires_at',
} as const;

export const tokenService = {
  getAccessToken: (): string | null => localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),

  getRefreshToken: (): string | null => localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),

  setTokens: (data: AuthTokensResponse): void => {
    const now = Date.now();
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, toString(data.access_token));
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, toString(data.refresh_token));
    localStorage.setItem(
      STORAGE_KEYS.ACCESS_TOKEN_EXPIRES_AT,
      toString(now + data.access_token_ttl * 1000),
    );
    localStorage.setItem(
      STORAGE_KEYS.REFRESH_TOKEN_EXPIRES_AT,
      toString(now + data.refresh_token_ttl * 1000),
    );
  },

  clearTokens: (): void => {
    Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
  },

  isAccessTokenExpired: (): boolean => {
    const expiresAt = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN_EXPIRES_AT);
    if (!expiresAt) return true;

    return Date.now() >= Number(expiresAt);
  },

  isAccessTokenExpiring: (bufferMs: number): boolean => {
    const expiresAt = tokenService.getAccessTokenExpiresAt();
    if (expiresAt === null) return true;

    return Date.now() >= expiresAt - bufferMs;
  },

  isRefreshTokenExpired: (): boolean => {
    const expiresAt = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN_EXPIRES_AT);
    if (!expiresAt) return true;

    return Date.now() >= Number(expiresAt);
  },

  hasTokens: (): boolean =>
    tokenService.getAccessToken() !== null && tokenService.getRefreshToken() !== null,

  hasAnyToken: (): boolean =>
    tokenService.getAccessToken() !== null || tokenService.getRefreshToken() !== null,

  getAccessTokenExpiresAt: (): number | null => {
    const expiresAt = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN_EXPIRES_AT);

    return expiresAt ? Number(expiresAt) : null;
  },

  getRefreshTokenExpiresAt: (): number | null => {
    const expiresAt = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN_EXPIRES_AT);

    return expiresAt ? Number(expiresAt) : null;
  },
};

export default tokenService;
